module.exports = __webpack_public_path__ + "static/img/37.418a25ff.gif";